import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AsstesService } from '../assets/asstes.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-delete-asset-list',
  templateUrl: './delete-asset-list.component.html',
  styleUrls: ['./delete-asset-list.component.scss']
})
export class DeleteAssetListComponent implements OnInit {
  modalOpen: boolean;
  assets;
  row;
  column;
  type;
  sequenceOfAssets;
  showingList;
  getAssetValues: any;
  constructor(
    public activeModal: NgbActiveModal,
    private _assetService: AsstesService
  ) {}

  ngOnInit() {
  }
  close() {
    this.activeModal.dismiss();
  }

  deleteimage(row, column, assets, type): void {
    const assetId = assets[type][row]._id;
    this._assetService.deleteAsset(assetId).
    subscribe(
      (res) => {

        let parentAssetData: any = this.assets[type].filter(function(asset) {
          return asset._id !== assetId;
        });
        this.assets[type] = parentAssetData;
        if (parentAssetData.length === 0) {
          delete this.assets[type];
          if (column === 0) {
            this.sequenceOfAssets.pop(); 
            this.getAssetValues({
              assets :  this.assets = {
                main: []
              },
              sequenceOfAssets : ["main"],
              showingList : false
            });
          } else {
            this.assets[type] = [{ _id: '', name: "" }];
          }
        }

        this.sequenceOfAssets.splice(column, this.assets[type][row] - column);
        delete(this.assets[assetId]);

        if (column === 0) {
          this.sequenceOfAssets = ["main"];
        }
      },
      (err) => {
        console.log(err);
      }
    )
    this.activeModal.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/app/delete-asset-list/delete-asset-list.component.ts